import { render, staticRenderFns } from "./ProductRegistration.vue?vue&type=template&id=0c74344b"
import script from "./ProductRegistration.vue?vue&type=script&lang=js"
export * from "./ProductRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports